export default __webpack_public_path__ + "d145e3a229b07dc133e17f061cd90fbc.png";